<script>
export default {
  name: "VocabNavbar"
};
</script>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { RouterLink, useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const currentRoute = computed(() => route.name);

const items = computed(() => [
  {
    name: "vocab.home",
    label: t("vocab.menuItems.home"),
    to: { name: "vocab.home" }
  },
  {
    name: "vocab.achievements",
    label: t("vocab.menuItems.achievements"),
    to: { name: "vocab.achievements" }
  }
]);
</script>

<template>
  <nav class="vocab-navbar">
    <div class="container vocab-navbar__item-container">
      <div class="row">
        <ul class="col-12 vocab-navbar__menu-bar" role="menubar">
          <template v-for="item in items" :key="item.name">
            <li
              role="menuitem"
              class="vocab-navbar__item"
              :class="{ 'vocab-navbar__item--active': currentRoute === item.name }"
            >
              <RouterLink :to="item.to" class="vocab-navbar__link">{{ item.label }}</RouterLink>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.vocab-navbar {
  display: flex;
  height: 44px;
  padding: 8px 0;
  background: rgb(@theme-colors[@primary][base]);
  box-shadow: 6px 6px 30px rgba(0, 0, 0, 0.1);
  color: white;
}

.vocab-navbar__item-container {
  cursor: default;
}

.vocab-navbar__menu-bar {
  display: flex;
  gap: 10px;
  margin: 0;
  list-style-type: none;
}

.vocab-navbar__item {
  height: 28px;
  padding: 2px 6px;

  &:hover,
  &--active {
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.2);
  }
}

.vocab-navbar__link {
  outline-offset: 4px;
  color: rgb(@colors[@white]);

  &:hover {
    text-decoration: none;
  }
}
</style>
